import { CHAT_MESSAGE_SPACING } from "../../Chat/constants";
import { type BookedShiftMessageProps } from "../../Chat/type";
import { parseShiftInviteChatMessage } from "../../Chat/utils";
import { ChatSeparator } from "./ChatSeparator";

export function BookedShiftMessage(props: BookedShiftMessageProps) {
  const { agentMessage } = parseShiftInviteChatMessage(props);

  return <ChatSeparator sx={{ marginY: CHAT_MESSAGE_SPACING }}>{agentMessage}</ChatSeparator>;
}
